import { css, html } from "lit";
import { customElement, property, query } from "lit/decorators.js";
import { Style } from "../Styles";
import { BaseElement } from "../BaseElement";
import routie from "routie";

import SlDialog from "@shoelace-style/shoelace/dist/components/dialog/dialog";

import "./UserProfile";
import { LightTheme } from "../ThemeLight";

@customElement("ds-user-profile-dialog")
export class UserProfileDialog extends BaseElement {
    static override styles = [
        Style,
        LightTheme,
        css`
            ds-user-profile {
                width: 100%;
                height: 100%;
            }

            .container {
                width: 100%;
                height: 100%;
                max-width: 1024px;
                margin-left: auto;
                margin-right: auto;
            }

            .full-screen-dialog::part(panel) {
                background-color: transparent;
            }
        `,
    ];
    @property({ type: String }) userId?: string;

    @query("#dialog") protected _dialog: SlDialog | undefined;

    public hide() {
        this._dialog?.hide();
        routie("/");
    }

    public show() {
        this._dialog?.show();
    }

    override render() {
        return html` <sl-dialog
            open
            no-header
            id="dialog"
            class="full-screen-dialog"
            @sl-after-hide=${(e: Event) => {
                if (e.eventPhase !== e.AT_TARGET) {
                    e.stopPropagation();
                }
            }}
        >
            <div class="container flex-column">
                <ds-user-profile
                    id="user-profile"
                    .userId=${this.userId}
                    @ds-close=${() => this.hide()}
                ></ds-user-profile>
            </div>
        </sl-dialog>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-user-profile-dialog": UserProfileDialog;
    }
}
